import { Component, Input } from '@angular/core';
import { ErrorLog } from '@shared/stores/error.store';

@Component({
    selector: 'nmfta-error-notification-modal',
    imports: [],
    templateUrl: './error-notification-modal.component.html',
    styleUrl: './error-notification-modal.component.scss'
})
export class ErrorNotificationModalComponent {
  @Input() data!: ErrorLog[];
}
